import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/core/Checkbox.atom';
import { VersionHistoryOperations } from '@/core/hooks/useVersionState.hook';
import { InputGroup, Select, TextArea } from '@seeqdev/qomponents';
import type { VersionState } from '@/core/hooks/useVersionState.hook';

interface VersioningSectionProps {
  versionState: VersionState;
}

export const VersioningSection = ({ versionState }: VersioningSectionProps) => {
  const { t } = useTranslation();
  const {
    versionHistoryOperation,
    selectedVersionHistory,
    newWorkbookName,
    handleSetNewWorkbookName,
    handleSetNotes,
    handleSetOperation,
    handleSelectVersionHistory,
    writeableVersionHistoryOptions,
  } = versionState;

  return (
    <div className="flexRowContainer" data-testid="version-history-radio-group">
      <div>
        <Checkbox
          id="radio-version-history-update"
          type="radio"
          value={VersionHistoryOperations.Update}
          isChecked={versionHistoryOperation === VersionHistoryOperations.Update}
          onChange={() => handleSetOperation(VersionHistoryOperations.Update)}
          label={t('ACCESS_CONTROL.LOCKING.VERSIONING.UPDATE_EXISTING_VERSION_HISTORY')}
        />
        <div className="ml20 width-300" data-testid="version-history-select">
          <Select
            options={writeableVersionHistoryOptions}
            value={selectedVersionHistory}
            placeholder={t('ACCESS_CONTROL.LOCKING.VERSIONING.SELECT_VERSION_HISTORY')}
            onChange={(option) => handleSelectVersionHistory(option)}
            isDisabled={versionHistoryOperation !== VersionHistoryOperations.Update}
            menuPlacement="bottom"
            menuPortalTarget={document.body}
          />
        </div>
      </div>

      <div className="mt20">
        <Checkbox
          id="radio-version-history-new"
          type="radio"
          value={VersionHistoryOperations.Create}
          isChecked={versionHistoryOperation === VersionHistoryOperations.Create}
          onChange={() => handleSetOperation(VersionHistoryOperations.Create)}
          label={t('ACCESS_CONTROL.LOCKING.VERSIONING.CREATE_NEW_VERSION_HISTORY')}
        />

        <div className="ml20 mb20 width-300">
          <div className="flexColumnContainer flexAlignEnd">
            <InputGroup
              type="text"
              value={newWorkbookName}
              disabled={versionHistoryOperation === VersionHistoryOperations.Update}
              testId="rename-workbook-input"
              onChange={(e) => handleSetNewWorkbookName(e.target.value)}
              placeholder={t('ACCESS_CONTROL.LOCKING.VERSIONING.ENTER_NEW_NAME')}
              append={[]}
              showError={!!versionState.newWorkbookNameError}
            />
            <div className="ml5">{`${t('ACCESS_CONTROL.LOCKING.VERSIONING.V')}1`}</div>
          </div>
          <div className="error-text">{versionState.newWorkbookNameError}</div>
        </div>

        <div className="mt20 width-500">
          <div className="mb5">{t('ACCESS_CONTROL.LOCKING.VERSIONING.VERSION_NOTES_LABEL')}</div>
          <TextArea
            extraClassNames="width-500"
            testId="version-notes-textarea"
            onChange={(e) => handleSetNotes(e.target.value)}
            placeholder={t('ACCESS_CONTROL.LOCKING.VERSIONING.NOTES_PLACEHOLDER')}
          />
        </div>
      </div>
    </div>
  );
};
